<template lang="html">
	<div class="upload_wrap">
		<el-upload class="avatar-uploader" :action="action" :headers="headers" :show-file-list="false" :before-upload="before_upload" :on-success="on_success" :on-error="on_error" accept=".jpg,.JPG,.mp4,.MP4">
			<span v-if="value">
				<video v-if="suffix(value)" :src="value" controls="controls" class="avatar"></video>
				<img v-else :src="value" class="avatar"/>
			</span>
			<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
	</div>
</template>
<script>
import { uploadOSS,deleteOSS } from '@/utils/oss';
// import {matchType} from '@/utils/matchType.js'
export default {
	name: 'upload_image',
	data() {
		return {
			action:process.env.API_ROOT+'uploadImage',
			headers:{
				'Accept': 'application/json, text/plain, */*' //配置请求头
			},
			loading:null,
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		size: {
			type: [String,Number],
			default: ''
		},
		name_name: {
			type: String,
			default: ''
		},
		file_name: {
			type: String,
			default: 'image' //file video
		}
	},
	methods: {
		on_success(res,file){
			console.log(res);
			if (res.code==0) {
				this.$message.success('图片上传成功');
				this.$emit('callback',res.data);
			}else{
				this.$message.error(res.msg);
			}
			this.loading.close();
		},
		on_error(){
			this.loading.close();
		},
		async fnUploadRequest(options){
			try {
				let file = options.file;
				let res = await uploadOSS(this.file_name+'/'+file.name,file);
	            this.$emit('callback', res);
				this.$message.success("上传成功！");
				this.loading.close();
			} catch (e) {
				this.$message.error('上传失败！');
				this.loading.close();
			}
		},
		before_upload(data){
			if(data.size>this.size){
				if(this.name_name=='个人高清形象照'){
					this.$message.error('个人高清形象照大小请控制在1MB以内！');
				}else{
					this.$message.error('高清作品图/视频大小请控制在15MB以内！');
				}
				return false
			}
			var name = ['jpg','JPG','mp4','MP4'];
			if(this.name_name=='个人高清形象照'){
				name = ['jpg','JPG'];
			}
			var file_name=data.name.split('.')[data.name.split('.').length-1];
			if(name.indexOf(file_name)==-1){
				if(this.name_name=='个人高清形象照'){
					this.$message.error('上传文件后缀jpg');
				}else{
					this.$message.error('上传文件后缀jpg/mp4，仅限上传一个图片或视频，多图、多角度、多个视频，请自行拼接上传');
				}
				return false
			}
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		suffix(data){
			var name=['mp4','mov','avi'];
			var data_arr = data.split('.');
			var suffix_name =data_arr[data_arr.length-1];
			if(name.indexOf(suffix_name)!=-1){
				return true
			}
			return false
		}
	}
}
</script>
<style lang="css">
.upload_wrap .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	display: block;
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
	text-align: center;
}
.upload_wrap .avatar-uploader .el-upload .el-upload__input {
    display: none!important;
}
.upload_wrap .avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.upload_wrap .avatar-uploader .el-upload .avatar{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.upload_wrap .avatar-uploader .avatar-uploader-icon {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/upload_local.vue